module.exports = __webpack_public_path__ + "static/media/1.7aae3963.png";